<template>
  <v-card id="promotion-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.RoleUpdate')"
          @click="createDialog = true"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="roles"
      :loading="loading"
      class="text-no-wrap"
    >
      <template #[`item.name`]="{item}">
        {{ item.name }}
      </template>

      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.RoleUpdate')"
                v-bind="attrs"
                :to="{ name: 'role-edit', params: { id: item.id } }"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Права роли</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  icon
                  small
                  :disabled="hasNotPermission('Permissions.RoleUpdate') || isSystem(item.name)"
                  @click="deletePopupShow(item)"
                >
                  <v-icon size="18">
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <span>{{ isSystem(item.name) ? 'Системную роль удалить нельзя' : 'Удалить' }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <delete-dialog
      ref="deletePopup"
      :label="deleteLabel"
      @delete-confirmed="removeRole"
    />
    <role-create-dialog
      :show="createDialog"
      :cancellation="() => { createDialog = false }"
    ></role-create-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEyeOutline,
  mdiPencilOutline,
} from '@mdi/js'
import { hasPermission } from '@/helpers'
import DeleteDialog from '@/components/delete-dialog'
import RoleCreateDialog from './role-create-dialog'

const SYSTEM_ROLES = ['Admin', 'Customer', 'Operator']

export default {
  name: 'RoleList',
  components: { DeleteDialog, RoleCreateDialog },
  data: () => ({
    createDialog: false,
    updateDialog: false,
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiEyeOutline,
    },
    deleteMethod: null,
    deleteLabel: '',
  }),
  computed: {
    ...mapState('role', {
      roles: 'list',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Наименование', value: 'name' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Роли'
    this.fetchRoles()
  },
  methods: {
    ...mapActions('role', {
      fetchRoles: 'fetchList',
      removeRole: 'remove',
    }),
    isSystem(name) {
      return SYSTEM_ROLES.includes(name)
    },
    deletePopupShow(role) {
      this.deleteLabel = `Роль ${role.name} будет удалена.`
      this.$refs.deletePopup.open(role.id)
    },
    hasNotPermission(val) {
      return !hasPermission(val)
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
